import React, {FC} from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  position: relative;
  z-index: 50;
`

const LeftContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`

const RightContent = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
`

interface StyledButtonGroupsProps {
  leftContent: React.ReactNode
  rightContent?: React.ReactNode
  leftContentProps?: React.HTMLAttributes<HTMLDivElement>
  rightContentProps?: React.HTMLAttributes<HTMLDivElement>
  children?: React.ReactNode
}

export const StyledButtonGroups: FC<StyledButtonGroupsProps> = (props) => {
  return (
    <Wrapper>
      <LeftContent {...props.leftContentProps}>{props.leftContent}</LeftContent>
      <RightContent {...props.rightContentProps}>{props.rightContent}</RightContent>
      {props.children}
    </Wrapper>
  )
}
